// removed by extract-text-webpack-plugin


/*****************
 ** WEBPACK FOOTER
 ** ./app/modules/footer/stylesheet/style.scss
 ** module id = 434
 ** module chunks = 1
 **/